import { useState } from "react";
import { toast } from "sonner";
import { Modal } from "./Modal";
import { toDateInput } from "../utils/calendarHelpers";

const INPUT_CLS = "mt-1.5 w-full px-3.5 py-2.5 rounded-lg border text-sm text-slate-900 focus:outline-none focus:ring-4 focus:ring-blue-500/10 focus:border-blue-400 transition-all";
const INPUT_STYLE = { borderColor: "var(--hx-border)" };

export function MaintenanceModal({ onClose, onSave, defaultDate }) {
  const initDate = toDateInput(defaultDate);
  const [form, setForm] = useState({ start_date: initDate, end_date: initDate, notes: "" });
  const [loading, setLoading] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    if (!form.start_date || !form.end_date) { toast.error("Start and end dates are required"); return; }
    if (form.end_date < form.start_date) { toast.error("End date must be after start date"); return; }
    setLoading(true);
    try {
      await onSave({ type: "maintenance", client_name: "", client_mobile: "", ...form });
      onClose();
    } catch {
      // handled upstream
    } finally {
      setLoading(false);
    }
  }

  return (
    <Modal title="Schedule Maintenance" onClose={onClose} accent="blue">
      <form onSubmit={handleSubmit} className="space-y-4">
        <div className="p-3 rounded-lg bg-blue-50 border border-blue-100 text-xs text-blue-700 leading-relaxed -mt-1">
          Selected dates will appear blue on the calendar. Hoarding status updates to <strong>Maintenance</strong> if today falls within this window.
        </div>

        <div className="grid grid-cols-2 gap-3">
          <div>
            <label className="text-xs font-semibold text-slate-500 uppercase tracking-wide">Start Date</label>
            <input type="date" value={form.start_date} onChange={e => setForm(f => ({ ...f, start_date: e.target.value }))} required className={INPUT_CLS} style={INPUT_STYLE} />
          </div>
          <div>
            <label className="text-xs font-semibold text-slate-500 uppercase tracking-wide">End Date</label>
            <input type="date" value={form.end_date} min={form.start_date} onChange={e => setForm(f => ({ ...f, end_date: e.target.value }))} required className={INPUT_CLS} style={INPUT_STYLE} />
          </div>
        </div>

        <div>
          <label className="text-xs font-semibold text-slate-500 uppercase tracking-wide">Reason / Notes</label>
          <textarea value={form.notes} onChange={e => setForm(f => ({ ...f, notes: e.target.value }))} rows={2} placeholder="e.g. Structural inspection, LED panel replacement…" className={`${INPUT_CLS} resize-none`} style={INPUT_STYLE} />
        </div>

        <div className="flex gap-2 pt-1">
          <button type="button" onClick={onClose} className="hx-secondary-action flex-1">Cancel</button>
          <button type="submit" disabled={loading} className="hx-primary-action flex-1">
            {loading ? "Saving…" : "Schedule"}
          </button>
        </div>
      </form>
    </Modal>
  );
}
